import React from 'react'
import ReactHtmlParser from 'react-html-parser';

/**
  * @class Basics
  * Show basics
*/
class BasicDetail extends React.Component {

  render() {
    const basic = this.props.basic
    return <div className="row">
      <div className="col-sm-8 skills__desc">
      <h3>{ basic.title }</h3>
        <b>{ basic.subtitle}</b>
        { ReactHtmlParser(basic.content) }
      </div>
      <div className="col-sm-4 img__content">
        <img src={ process.env.PUBLIC_URL + "/images/big-" + basic.picto } alt="" />
      </div>
    </div>
  }
}

export default BasicDetail




// WEBPACK FOOTER //
// ./src/components/Basics/BasicDetail.jsx